module.exports = __webpack_public_path__ + "img/vr_detail.3b02e4fd.jpg";